<template>
  <div class="login-box">
    <div class="login-con clear">
      <div class="login-dec"></div>
      <div class="ms-login">
        <p class="login-logo">智OA后台管理系统</p>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="login-form">
          <el-form-item prop="mobile">
            <label class="login-label">手机号</label>
            <el-input maxlength="11" clearable v-model="ruleForm.mobile" placeholder="输入手机号" class="login-edit"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <label class="login-label">密&nbsp;&nbsp;&nbsp;码</label>
            <el-input type="password" show-password placeholder="输入密码" v-model="ruleForm.password"
                      @keyup.enter.native="submitForm('ruleForm')" class="login-edit"></el-input>
          </el-form-item>
          <div class="login-btn">
            <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import { utils } from '../assets/js/utils';
  export default {
    data() {
      return {
        ruleForm: {
          mobile: '',
          password: ''
        },
        rules: {
          mobile: [
            {required: true,validator:utils.isPoneAvailable, trigger: 'blur'},
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'blur'}
          ]
        }
      }
    },
    methods: {
      submitForm(formName) {
        let that = this;
        let redirectPath=this.$route.query.redirect;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.$post({
              url:'auth/login',
              data:{'username': that.ruleForm.mobile,'password': that.$md5(that.ruleForm.password)},
              isToken:false,
            }).then(res=>{
              that.$setLocal('oaToken',res.token)
              that.$setLocal('oaUser',that.$Encrypt(JSON.stringify(res.user)))
              if(res.url!="" && res.url!=null && res.url!=undefined){
                that.$setLocal('oaLogo',res.url)
              }else{
                res.url=utils.qiniuAddr+'1567760286141'
                that.$setLocal('oaLogo',res.url)
              }
              this.$store.commit('setLogo',res.url)
              
              that.$message.success('登录成功');
             
              //获取权限字段
              this.publicMenu();   
              setTimeout(function(){
                that.$router.replace({    
                    path: '/home'   
                });
                // if(redirectPath){
                //   that.$router.replace({    
                //     path: redirectPath   
                //   });
                // }else{
                //   that.$router.replace({    
                //     path: '/'   
                //   });
                // }  
              },1000)             
                     
            },rej=>{});
          } else {
            console.log('请输入正确的数据')
            return false;
          }
        });
      },
      publicMenu(){
          this.$post({
              url: "system/menu/permission",
              data: {}
          }).then(
              res=>{
                this.$setLocal('permissionList',res)
              },
              rej=>{}                
          )
      }
    }
  }
</script>

<style scoped>
  .login-box {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: url("../assets/images/loginBg.jpg") center no-repeat;
    background-size: 100% 100%;
  }

  .login-con {
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -540px;
    margin-top: -300px;
    width: 1080px;
    z-index: 9;
    border-radius: 4px;
    overflow: hidden;
  }

  .login-logo {
    position: relative;
    height: 50px;
    text-align: center;
    font-size: 26px;
    color: #505050;
  }
  .login-logo::after{
    position: absolute;
    content: "";
    bottom: 0;
    left: 50%;
    margin-left: -54px;
    width: 108px;
    height: 2px;
    background: #5974F3;
  }

  .login-dec {
    float: left;  
    width: 603px;
    height: 600px;
    background: url("../assets/images/loginPic.jpg") center no-repeat;
  }
  .ms-login {
    box-sizing: border-box;
    padding: 100px 70px 0;
    float: right;
    width: 477px;
    height: 600px;
    background: #fff;
  }

  .login-form {
    margin-top: 70px;    
  }

  .login-form li {
    margin-bottom: 40px;
  }

  .login-icon {
    float: left;
    display: inline-block;
    margin-right: 14px;
    margin-top: 10px;
    width: 18px;
  }

  .login-label {
    display: block;
    margin-bottom: 2px;
    font-size: 16px;
    color: #666;
  }

  .login-btn {
    margin-top: 40px;
  }

  .el-button {
    display: block;
    width: 100%;
    height: 52px;
    border: none;
    font-size: 16px;
  }
  .module-name {

  }
  .module-label {
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue